module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm_title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("List of Maps")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-b"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Note:")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Unless otherwise stated, the maps are extracts from trench maps or from the relevant histories; the sketch and tour maps were prepared for this book.")])]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "numhang"
  }, [_vm._v("1.")]), _vm._v(" Modern map showing the area of the British sector of the Somme 1916 battlefield.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "numhang"
  }, [_vm._v("2.")]), _vm._v(" Modern detailed map of the fighting from Martinpuich to the Butte de Warlencourt.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "numhang"
  }, [_vm._v("3.")]), _vm._v(" The area of the Fourth Army’s operations: 15 September 1916.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "numhang"
  }, [_vm._v("4.")]), _vm._v(" Sketch map illustrating the attack of 15 September 1916 (the 15th, 50th and 47th Divisions).")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "numhang"
  }, [_vm._v("5.")]), _vm._v(" Location of trenches in the Martinpuich area, map dated 30 July 1916.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "numhang"
  }, [_vm._v("6.")]), _vm._v(" Sketch map illustrating the attack of the 15th Division on Martinpuich, 15 September 1916.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "numhang"
  }, [_vm._v("7.")]), _vm._v(" The area over which the 50th Division attacked on 15 September 1916.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "numhang"
  }, [_vm._v("8.")]), _vm._v(" The 47th Division’s front on 15 September 1916.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "numhang"
  }, [_vm._v("9.")]), _vm._v(" Overview of the fighting of 1–3 October 1916, showing the positions of the 47th, 50th and 23rd Divisions.")]), _vm._v(" "), _c('p', {
    staticClass: "num-1"
  }, [_c('span', {
    staticClass: "numhangj"
  }, [_vm._v("10.")]), _vm._v(" Modern map covering the area of operations on 7–8 October 1916.")]), _vm._v(" "), _c('p', {
    staticClass: "num-1"
  }, [_c('span', {
    staticClass: "numhangj"
  }, [_vm._v("11.")]), _vm._v(" The trenches around Le Sars.")]), _vm._v(" "), _c('p', {
    staticClass: "num-1"
  }, [_c('span', {
    staticClass: "numhangj"
  }, [_vm._v("12.")]), _vm._v(" Le Sars and Eaucourt L’Abbaye, showing the site of the ‘Mill’.")]), _vm._v(" "), _c('p', {
    staticClass: "num-1"
  }, [_c('span', {
    staticClass: "numhangj"
  }, [_vm._v("13.")]), _vm._v(" Map (Eaucourt l’Abbaye to the Butte) of the battlefield, 30 October 1916, from 149 Brigade’s diary.")]), _vm._v(" "), _c('p', {
    staticClass: "num-1"
  }, [_c('span', {
    staticClass: "numhangj"
  }, [_vm._v("14.")]), _vm._v(" The location of the Pimple and several key trenches that featured in the attacks on the Butte.")]), _vm._v(" "), _c('p', {
    staticClass: "num-1"
  }, [_c('span', {
    staticClass: "numhangj"
  }, [_vm._v("15.")]), _vm._v(" Location of The Tail and Snag Trench, dated 1 January 1917.")]), _vm._v(" "), _c('p', {
    staticClass: "num-1"
  }, [_c('span', {
    staticClass: "numhangj"
  }, [_vm._v("16.")]), _vm._v(" The lines around the Butte, 1 January 1917.")]), _vm._v(" "), _c('p', {
    staticClass: "num-1"
  }, [_c('span', {
    staticClass: "numhangj"
  }, [_vm._v("17.")]), _vm._v(" Walking Tour One outline map.")]), _vm._v(" "), _c('p', {
    staticClass: "num-1"
  }, [_c('span', {
    staticClass: "numhangj"
  }, [_vm._v("18.")]), _vm._v(" Walking Tour Two outline map.")]), _vm._v(" "), _c('p', {
    staticClass: "num-1"
  }, [_c('span', {
    staticClass: "numhangj"
  }, [_vm._v("19.")]), _vm._v(" South of Martinpuich, dated September 1916.")]), _vm._v(" "), _c('p', {
    staticClass: "num-1"
  }, [_c('span', {
    staticClass: "numhangj"
  }, [_vm._v("20.")]), _vm._v(" Trenches north of the High Wood to Bazentin road.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "num-1"
  }, [_c('span', {
    staticClass: "numhangj"
  }, [_vm._v("21.")]), _vm._v(" Trenches north and north west of Bazentin le Petit to north west edge of High Wood, dated September 1916.")]), _vm._v(" "), _c('p', {
    staticClass: "num-1"
  }, [_c('span', {
    staticClass: "numhangj"
  }, [_vm._v("22.")]), _vm._v(" Locations of Tangle Trench and Tangle South and North, dated 29 September 1916.")]), _vm._v(" "), _c('p', {
    staticClass: "num-1"
  }, [_c('span', {
    staticClass: "numhangj"
  }, [_vm._v("23.")]), _vm._v(" Car Tour outline map.")]), _vm._v(" "), _c('p', {
    staticClass: "num-1"
  }, [_c('span', {
    staticClass: "numhangj"
  }, [_vm._v("24.")]), _vm._v(" Le Sars and area, September 1916.")]), _vm._v(" "), _c('p', {
    staticClass: "num-1"
  }, [_c('span', {
    staticClass: "numhangj"
  }, [_vm._v("25.")]), _vm._v(" Sketch map of the 1870–71 battlefield around Bapaume.")]), _vm._v(" "), _c('p', {
    staticClass: "num-1"
  }, [_c('span', {
    staticClass: "numhangj"
  }, [_vm._v("26.")]), _vm._v(" German defences around Grévillers, Sapignies and Favreuil, dated 27 November 1916.")]), _vm._v(" "), _c('p', {
    staticClass: "num-1"
  }, [_c('span', {
    staticClass: "numhangj"
  }, [_vm._v("27.")]), _vm._v(" Detail of German defences, including Grevillers, Coulle and Grundy trenches, dated 1 January 1917.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3203601e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_List-Maps.vue
// module id = 72
// module chunks = 0